import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import TutorialNavigator from '../../quickstarts/TutorialNavigator';
import QuickstartStore from '../../../stores/QuickstartStore';
import NavigationStore from '../../../stores/NavigationStore';
import UserStore from '../../../stores/UserStore';
import CuratedCards from '../../CuratedCards';
import JobsToBeDone from '../../JobsToBeDone';
import SearchBox from '../../SearchBox';
import Spinner from '../../Spinner';
import styles from './styles.module.styl';

const HomePage = props => (
  <div className={styles.homeContainer}>
    <div className={styles.topFold}>
      <div className="container">
        <SearchBox placeholder="Search the docs" />
      </div>
      {!props.quickstarts
        ? <Spinner />
        : <TutorialNavigator
          largeHeader
          firstQuestion={'Start Building'}
          subHeader={'Choose your application type to get started'}
          onHomePage
          {...props}
        />
      }
    </div>

    <JobsToBeDone />
    <CuratedCards cards={props.cards} />
  </div>
);

HomePage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  quickstarts: PropTypes.object,
  cards: PropTypes.array
};

HomePage.contextTypes = {
  getStore: PropTypes.func
};

export default connectToStores(HomePage, [NavigationStore, QuickstartStore], (context) => ({
  isAuthenticated: context.getStore(UserStore).isAuthenticated(),
  quickstarts: context.getStore(QuickstartStore).getQuickstarts(),
  cards: context.getStore(NavigationStore).getCards()
}));
